(function () {
  'use strict';

  // Carosello a scroll nativo: dito su mobile, drag col cursore su desktop.
  // Lo snap (se voluto) si gestisce in CSS con scroll-snap-type sul track.
  function initDragScroller(root, opts) {
    if (!root) return;
    var track = opts.track ? root.querySelector(opts.track) : root;
    var dots = opts.dot ? root.querySelectorAll(opts.dot) : [];
    if (!track || !track.children.length) return;

    var count = track.children.length;
    var timer;
    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var moved = 0;

    // Passo tra due slide: larghezza reale della card + gap del track.
    // Con le slide a vista parziale (peek) la card non è larga quanto il track,
    // quindi non si può usare track.clientWidth per indicizzare.
    function slideStep() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var w = first.getBoundingClientRect().width;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return w + gap || track.clientWidth;
    }

    function currentIndex() {
      return Math.round(track.scrollLeft / slideStep());
    }

    function syncDots() {
      var i = currentIndex();
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === i);
        dot.setAttribute('aria-selected', di === i ? 'true' : 'false');
      });
    }

    function goTo(i, smooth) {
      i = (i + count) % count;
      track.scrollTo({ left: i * slideStep(), behavior: smooth ? 'smooth' : 'auto' });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(i, true);
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(syncDots);
      },
      { passive: true }
    );

    // Drag col mouse su desktop — il touch usa lo scroll nativo del browser.
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      dragging = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      moved = 0;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
      clearInterval(timer);
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      moved = Math.max(moved, Math.abs(e.clientX - startX));
      track.scrollLeft = startScroll - (e.clientX - startX);
    });

    // Dopo un drag vero il click sui link interni non deve navigare.
    track.addEventListener(
      'click',
      function (e) {
        if (moved > 8) {
          e.preventDefault();
          e.stopPropagation();
          moved = 0;
        }
      },
      true
    );

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      // Marco 05/08: lasciando la presa la slide restava a meta' strada. Lo
      // scroll-snap del CSS non interviene qui perche' durante il drag lo
      // scrollLeft lo muove il JS, e per il browser non e' un gesto di scroll:
      // l'aggancio alla slide piu' vicina va chiesto a mano.
      goTo(currentIndex(), true);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function (e) {
      if (dragging && e.pointerType !== 'touch') endDrag(e);
    });

    if (opts.autoplay) {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(function () {
          goTo(currentIndex() + 1, true);
        }, opts.interval || 4200);
      }
    }

    syncDots();
  }

  function initTabs(root) {
    if (!root) return;
    var tabs = root.querySelectorAll('[data-gg-home-tab]');
    var panels = root.querySelectorAll('[data-gg-home-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var group = tab.dataset.ggHomeTab;
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.dataset.ggHomePanel === group);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-gg-home-hero]').forEach(function (el) {
      initDragScroller(el, {
        track: '[data-gg-home-hero-track]',
        dot: '[data-gg-home-hero-dot]',
        autoplay: true,
        interval: parseInt(el.getAttribute('data-gg-home-hero-interval'), 10) || 7000
      });
    });

    document.querySelectorAll('[data-gg-home-process]').forEach(function (el) {
      initDragScroller(el, {
        track: '[data-gg-home-process-track]',
        dot: '[data-gg-home-process-dot]',
        autoplay: false
      });
    });

    document.querySelectorAll('[data-gg-home-featured]').forEach(initTabs);

    // Caroselli generici: l'elemento con [data-gg-drag-scroller] è già il track
    // (contiene le slide come figli diretti), quindi niente opzione `track`.
    // Senza questo su desktop col mouse le slide fuori vista erano irraggiungibili
    // (scrollbar nascosta, niente dots/frecce).
    document.querySelectorAll('[data-gg-drag-scroller]').forEach(function (el) {
      initDragScroller(el, {});
    });
  });
})();
